export default __webpack_public_path__ + "static/media/w_f_2021_a.13897e54.jpeg";